import React, { FC, useEffect, useState } from 'react'
import { IonSlides, IonSlide } from '@ionic/react'
import { observer } from 'mobx-react'
import { memberMobx, pointCardMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import PointCardItem from '../PointCardItem'
import './index.scss'

interface IProps { }

const PointCardModule: FC<IProps> = () => {
  const history = useHistoryNew()
  const { pointCardList, getPointCardList } = pointCardMobx
  const [isImg, setIsImg] = useState<boolean>(true)
  const initPointOpts = {
    initialSlide: 0,
    autoplay: false,
    loop: false,
    on: {
      slideChange () {
        const swiper = this as any
        setIsImg(pointCardList[swiper.activeIndex].extra?.bgType === 'img')
      }
    }
  }
  const handleGo = (path: string) => {
    mktController.checkLogin(history).then(() => {
      history.push(path)
    })
  }
  useEffect(() => {
    if (pointCardList.length === 0 && memberMobx.token) {
      getPointCardList()
    }
  }, [])
  useEffect(() => {
    if (pointCardList.length) setIsImg(pointCardList[0].extra?.bgType === 'img')
  }, [pointCardList])
  if (pointCardList.length === 0) return <></>
  return (
    <div className={`point-card-module${isImg ? '' : ' point-card-module-height'}`}>
      <IonSlides options={initPointOpts} class='card-slides'>
        {
          pointCardList.map((item: any, index: number) => (
            <IonSlide key={index}>
              <div className='card-area'>
                <PointCardItem
                  data={item}
                  onClick={(e) => handleGo(pointCardList.length === 1 ? `pointCard/detail/${item.activityId}` : '/pointCard')}
                />
              </div>
            </IonSlide>
          ))
        }
      </IonSlides>
    </div>
  )
}
export default observer(PointCardModule)
